import angular from 'angular';

import Modals from './modal';

import NotificationFactory from './notificationFactory';
import NotificationUtilityFactory from './notificationUtilityFactory';

import NotificationFooterController from './footer/notificationFooterController';
import NotificationFooterDirective from './footer/notificationFooterDirective';

export default angular.module('app.notificationCenter', [Modals])
    .controller('NotificationFooterController', NotificationFooterController)
    .factory('NotificationCenterFactory', NotificationFactory)
    .factory('NotificationUtility', NotificationUtilityFactory)
    .directive('hpNotificationFooter', NotificationFooterDirective)
    .run(($templateCache) => {
        $templateCache.put('app/notificationCenter/footer/notificationFooter.html', require('./footer/notificationFooter.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/notificationCenter/index.js